/** チャンネルイベント条件の条件タイプ */
export type ChannelEventConditionTypeType = 'GENERAL' | 'USECASE';
export const ChannelEventConditionTypeTypes: ChannelEventConditionTypeType[] = ['GENERAL', 'USECASE'];
export function convertChannelEventConditionTypeType(s?: string, undef?: boolean) {
  for (const v of ChannelEventConditionTypeTypes) if (v === s) return s;
  return undef ? undefined : ChannelEventConditionTypeTypes[0];
}
